export const KEYBOARD_SHORTCUTS = {
	calendar: ['control', 'shift', 'c'],
	filter: ['control', 'shift', 'f'],
	home: ['control', 'shift', 'h'],
	news: ['control', 'shift', 'n'],
	notifications: ['control', 'shift', 'm'],
	portfolios: ['control', 'shift', 'p'],
	search: ['control', 'shift', 'k'],
	theme: ['control', 'shift', 't'],
	user: ['control', 'shift', 'u'],
	watchlists: ['control', 'shift', 'w'],
};
